import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

import useQuestion from './useQuestion';

const useStyles = makeStyles((theme) => {
    return {
        select: {
            '&.MuiOutlinedInput-root': {
                borderRadius: '8px',
                width: 400,
            },
        },
        readOnlySelect: {
            '& > .MuiSelect-outlined.Mui-disabled': {
                backgroundColor: '#EFEFEF',
                color: '#586874',
                fontSize: '15px',
                '-webkit-text-fill-color': 'unset',
                outline: 'none',
            },
        },
    };
});

const SingleChoiceDropdown = (props) => {
    const { question, disabled, readOnly } = props;

    const { chosenVal, setChosenVal } = useQuestion(question);

    const classes = useStyles(props);

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Select
            size="small"
            value={chosenVal?.[0] ? chosenVal[0] : ''}
            onChange={(event) => setChosenVal([event.target.value])}
            disabled={disabled || readOnly}
            className={classNames({
                [classes.select]: true,
                [classes.readOnlySelect]: readOnly,
            })}
        >
            {question?.options?.map((opt) => (
                <MenuItem value={opt?.id}>{opt?.text?.['en-US']}</MenuItem>
            ))}
        </Select>
    );
};

export default SingleChoiceDropdown;
